<template>
    <el-select v-model="currentSelectId" clearable filterable remote :placeholder="placeholder"
               :remote-method="handleSearch"
               :loading="loading"
               @change="handleChange"
               style="width: 140px;">
        <el-option
            v-for="item in tableList.data"
            :key="item.id"
            :label="item.name"
            :value="item.id">

        </el-option>
        <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            :total="tableList.count"
            :current-page.sync="tableList.page"
            :page-size.sync="tableList.pageSize"
            @size-change="()=>tableList.load()"
            @current-change="()=>tableList.load()"
        >
        </el-pagination>
    </el-select>
</template>

<script>
    import lodash from 'lodash';
    export default {
        name: "SelectList",
        props: {
            value: [Number, String],
            permissionId: String,
            tableList: Object,
            placeholder: String,
            // loading: Boolean,
            // onSearch: Function,
        },
        data() {
            return {
                loading: false,
                currentSelectId: this.value,
            };
        },
        computed: {

        },
        methods: {
            handleChange(v) {
                // console.log("handleChange >>>", v);
                this.currentSelectId = v;
                this.$emit("input", this.currentSelectId);
            },
            handleSearch(keywords) {
                console.log("handleSearch >>>", keywords)
                const search = () => {
                    this.loading = true;
                    // console.log("this.tableList >>>", this.tableList);
                    this.tableList.searchForm.keywords = keywords;
                    this.tableList.load().then(() =>
                    {
                        this.loading = false;
                        return this.tableList.data;
                    });
                };

                lodash.debounce(search, 300)();
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/select/SelectList.vue